import { render } from "./LayoutView.vue?vue&type=template&id=3424bb01&scoped=true"
import script from "./LayoutView.vue?vue&type=script&lang=js"
export * from "./LayoutView.vue?vue&type=script&lang=js"

import "./LayoutView.vue?vue&type=style&index=0&id=3424bb01&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3424bb01"]])

export default __exports__